var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.isLoading)?_c('span',[_vm._v("Перенаправляем на платежную систему yookassa")]):(_vm.error)?_c('span',[_vm._v("Ошибка при попытке оплаты.")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }